import React,{useState,useEffect} from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import './styles/App.css';
import M_Footer from './M_Footer';
import {Link} from 'react-router-dom';
import TopTitle from './TopTitle';
import queryString from 'query-string';
import axios from 'axios';
import {currentDate,instance} from './common'
import check from './img/gg_check-o.png'


function LoadSigong({si_id}){
    const [data, setData] = useState([]);
    let obj = {si_id:si_id}

    useEffect(() => {
        
        const fetchData = async () => {
            instance.post('/sigong/id',obj).then(function(res){
                
                setData(res.data[0]);
            });
        
        };

        fetchData();

    }, []);

    const borderBottom = {
        borderBottom:'1px solid #ddd',
        marginTop:'50px'
    }

    console.log('확인 데이터 : ', data)
    return (
        <table className="table" style={borderBottom}>
            <thead>
            </thead>
            <tbody>
                <tr>
                    <td className="font-weight-bold text-center text-lightgray pt-3 pb-3">시공점</td>
                    <td className="font-weight-bold text-right pt-3 pb-3">{data.si_area1+ ' ' +data.si_area2+' '+data.si_name}</td>
                </tr>
                <tr>
                    <td className="font-weight-bold text-center text-lightgray pt-3 pb-3">예약정보</td>
                    <td className="font-weight-bold text-right pt-3 pb-3">{currentDate()}</td>
                </tr>
            </tbody>
            <tfoot></tfoot>
        </table>
    )
}
function RepReserve({ history, location, match }) {
    const session = JSON.parse(window.sessionStorage.result);
    const {u_id} = session;
    const query = queryString.parse(location.search);

    let si_id = query.si_id;
    let r_id = query.r_id;
    let date = query.date;


    const [data, setData] = useState([]);

    let obj = {r_id:r_id}
    useEffect(() => {
        
        const fetchData = async () => {
            instance.post('/reserve/r_id',obj).then(function(res){

                setData(res.data[0]);  
            });
 
        };

        fetchData();

    }, []);

    console.log('data : ', data)
    let contract_num = '';
    if(data.contract_num){
        contract_num = data.contract_num;
    }


    const goHome = () => {
        history.push('/');
    }

   return (
        <div className="container">
            <div className="text-center">
                <div className="mt-5 mb-5">
                    <img src={check} className="w-25 mt-5 mb-5"/>
                </div>
                <h2 className="font-weight-bold mb-5">신청이 완료되었습니다.</h2>
                <h4 className="text-lightgray">시공사 정보입력 이후로 작업내역을</h4>
                <h4 className="text-lightgray">확인할 수 있습니다.</h4>
            </div>
            <LoadSigong si_id={si_id}/> 

            <div className="mt-5">
                 {
                    contract_num
                    ?
                    <span className="btn btn-secondary r_btnsize">프로모션 인증완료</span>
                    :
                    <span className="btn btn-primary r_btnsize" onClick={()=> history.push('/RepInsert?r_id='+r_id+'&date='+date+'&si_id='+si_id)}>프로모션 인증(계약번호 인증)</span>
                    
                }
                <span className="btn_pad btn btn-primary btn-block mt-2" onClick={() => history.push('/myReserve')}>예약 내역</span>
                <span className="btn_pad btn btn-primary btn-block" onClick={goHome}>확인</span>
            </div>
        </div>
   );
}

export default RepReserve;
